import Vue from 'vue'
import Router from 'vue-router'
import { isNavigationFailure, NavigationFailureType } from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  {path: '/open-embed', component: () => import('@/views/open-embed/index'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: {title: '首页', icon: 'home'},
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '仪表盘', icon: 'dashboard'}
    },
    {
      path: 'profile',
      name: 'profile',
      component: () => import('@/views/profile/index'),
      meta: {title: '个人信息', icon: 'user'},
      /** 仅从右上角「我的」进入，不参与侧栏（避免与「仪表盘」并列成子菜单） */
      hidden: true
    },
    // {
    //   name: 'document',
    //   path: 'https://www.macrozheng.com',
    //   meta: {title: '学习教程', icon: 'document'}
    // },
    // {
    //   name: 'video',
    //   path: 'https://www.macrozheng.com/mall/foreword/mall_video.html',
    //   meta: {title: '视频教程', icon: 'video'}
    // },
    ]
  },
  {
    path:'/member',
    component: Layout,
    redirect: '/member/list',
    name: 'member',
    meta: {title: '会员', icon: 'member'},
    children: [
      {
        path: 'list',
        name: 'memberList',
        component: () => import('@/views/ums/member/index'),
        meta: {title: '会员管理', icon: 'member-list'}
      },
      {
        path: 'register',
        name: 'memberRegister',
        component: () => import('@/views/ums/member/register'),
        meta: {title: '注册会员', icon: 'member-list'}
      },
      {
        path: 'job',
        name: 'memberJob',
        component: () => import('@/views/ums/member/job/index'),
        meta: {title: '职业管理', icon: 'member-list', superAdminOnly: true}
      },
      {
        path: 'integration-rule-consent-log',
        name: 'memberIntegrationRuleConsentLog',
        component: () => import('@/views/ums/integration/rule-consent-log/index'),
        meta: {title: '会员协议记录', icon: 'document', superAdminOnly: true}
      },
      {
        path: 'integration-batch-expire',
        name: 'memberIntegrationBatchExpire',
        component: () => import('@/views/ums/member/integration-batch-expire/index.vue'),
        meta: {title: '积分批次到期', icon: 'document', superAdminOnly: true}
      },
      {
        path: 'sms-management',
        name: 'memberSmsManagement',
        component: () => import('@/views/ums/member/sms-management/index.vue'),
        meta: {title: '短信管理', icon: 'sms', superAdminOnly: true}
      }
    ]
  },
  {
    path: '/integration',
    component: Layout,
    redirect: '/integration/exchange-history',
    name: 'integration',
    /** 始终展开为子菜单，避免仅1 个可见子项时误用 children[0] 的 SidebarItem 逻辑 */
    meta: {title: '积分管理', icon: 'integration-rule', alwaysShow: true},
    children: [
      {
        path: 'rule/list',
        name: 'integrationRuleList',
        component: () => import('@/views/ums/integrationRule/index'),
        meta: {title: '积分规则管理', icon: 'integration-rule-list', superAdminOnly: true}
      },
      {
        path: 'inner-cash-config',
        name: 'innerIntegrationCashConfig',
        component: () => import('@/views/ums/integration/inner-cash-config/index.vue'),
        meta: {title: '兑换积分折现设置', icon: 'integration-rule-list', superAdminOnly: true}
      },
      {
        path: 'rule-consent-log',
        name: 'integrationRuleConsentLog',
        component: () => import('@/views/ums/integration/rule-consent-log/index'),
        meta: {title: '会员协议记录', icon: 'document', superAdminOnly: true}
      },
      {
        path: 'exchange-history',
        name: 'exchangeIntegrationHistory',
        component: () => import('@/views/ums/exchangeIntegrationHistory/index.vue'),
        meta: {title: '兑换积分流水', icon: 'member-list'}
      },
      {
        path: 'inner-integration-stats',
        name: 'innerIntegrationStatsReport',
        component: () => import('@/views/ums/integration/inner-integration-stats/index'),
        meta: {title: '积分统计报表', icon: 'chart'}
      },
      {
        path: 'inner-integration-display-adjustment',
        name: 'innerIntegrationDisplayAdjustment',
        component: () => import('@/views/ums/integration/inner-integration-stats/display-adjustment/index'),
        meta: {title: '冲减兑换积分', icon: 'chart', superAdminOnly: true}
      },
      {
        path: 'inner-integration-stats/detail',
        name: 'innerIntegrationStatsDetail',
        component: () => import('@/views/ums/integration/inner-integration-stats/detail'),
        meta: {title: '兑换积分统计明细', icon: 'chart'},
        hidden: true
      },
      {
        path: 'inner-integration-stats/monthly-by-company',
        name: 'innerIntegrationMonthlyByCompany',
        component: () => import('@/views/ums/integration/inner-integration-stats/monthly-by-company.vue'),
        meta: {title: '按月公司经营报表', icon: 'chart'},
        hidden: true
      },
      {
        path: 'inner-integration-stats/monthly-period',
        name: 'innerIntegrationMonthlyPeriodReport',
        component: () => import('@/views/ums/integration/inner-integration-stats/monthly-period.vue'),
        meta: {title: '月份积分汇报', icon: 'chart'},
        hidden: true
      },
      {
        path: 'inner-integration-stats/charts',
        name: 'innerIntegrationStatsCharts',
        component: () => import('@/views/ums/integration/inner-integration-stats/charts.vue'),
        meta: {title: '积分统计图表', icon: 'chart'},
        hidden: true
      },
      {
        path: 'gift-verify-card',
        name: 'adminGiftVerifyCard',
        component: () => import('@/views/integration/admin-gift-card/index'),
        meta: {title: '赠送卡券', icon: 'sms-coupon'}
      },
      {
        path: 'inner-gift-batch',
        name: 'innerIntegrationGiftBatch',
        component: () => import('@/views/ums/integration/inner-gift-batch/index'),
        meta: {title: '兑换积分批次', icon: 'member-list'}
      },
      {
        path: 'outer-gift-batch',
        name: 'outerIntegrationGiftBatch',
        component: () => import('@/views/ums/integration/outer-gift-batch/index.vue'),
        meta: {title: '抵扣积分批次', icon: 'member-list', superAdminOnly: true}
      },
      {
        path: 'inner-gift-activation',
        name: 'innerGiftActivation',
        component: () => import('@/views/ums/integration/inner-gift-activation/index'),
        meta: {title: '兑换积分激活', icon: 'member-list'}
      },
      {
        path: 'member-inner',
        name: 'integrationMemberInner',
        component: () => import('@/views/ums/integration/member-inner/index'),
        meta: {title: '会员兑换积分', icon: 'member-list', superAdminOnly: true}
      },
      {
        path: 'inner-operation-log',
        name: 'innerIntegrationOperationLog',
        component: () => import('@/views/ums/integration/inner-operation-log/index.vue'),
        meta: {title: '积分操作记录', icon: 'document', superAdminOnly: true}
      }
    ]
  },
  {
    path: '/company',
    component: Layout,
    redirect: '/company/list',
    name: 'company',
    meta: {title: '公司管理', icon: 'ums-admin'},
    children: [
      {
        path: 'list',
        name: 'companyList',
        component: () => import('@/views/ums/company/index.vue'),
        meta: {title: '公司列表', icon: 'ums-admin'}
      },
      {
        path: 'site',
        name: 'companySite',
        component: () => import('@/views/ums/company/site-index.vue'),
        meta: {title: '自提/到店网点', icon: 'marker'}
      },
      {
        path: 'fulfillment-partner',
        name: 'companyFulfillmentPartner',
        component: () => import('@/views/ums/company/fulfillment-partner-index.vue'),
        meta: {title: '公司履约委托', icon: 'link'}
      }
    ]
  },
  {path: '/integration-rule', redirect: '/integration/rule/list', hidden: true},
  {path: '/integration-rule/list', redirect: '/integration/rule/list', hidden: true},
  {path: '/member/exchangeIntegrationHistory', redirect: '/integration/exchange-history', hidden: true},
  {path: '/oms/verifyManage', redirect: '/verify/manage', hidden: true},
  {
    path:'/py-script',
    component: Layout,
    redirect: '/py-script/index',
    name: 'pyScript',
    meta: {title: '商城辅助工具', icon: 'tool'},
    children: [
      {
        path: 'index',
        name: 'pyScriptIndex',
        component: () => import('@/views/py-script/index'),
        meta: {title: '商城辅助工具', icon: 'tool'}
      }
    ]
  },
  {
    path:'/behavior-analysis',
    component: Layout,
    redirect: '/behavior-analysis/index',
    name: 'behaviorAnalysis',
    meta: {title: '用户行为分析', icon: 'chart'},
    children: [
      {
        path: 'index',
        name: 'behaviorAnalysisIndex',
        component: () => import('@/views/behavior-analysis/index'),
        meta: {title: '行为统计分析', icon: 'chart'}
      },
      {
        path: 'product-browse-detail/:productId',
        name: 'ProductBrowseDetail',
        component: () => import('@/views/behavior-analysis/product-browse-detail'),
        meta: {title: '商品浏览详情', icon: 'chart'},
        hidden: true
      }
    ]
  },
  /** 核销：放在 constantRouterMap，与会员/积分一致，不依赖后台菜单下发即可访问最新页面 */
  {
    path: '/verify',
    component: Layout,
    redirect: '/verify/manage',
    name: 'verify',
    meta: {title: '核销', icon: 'form', allowWithoutMenu: true},
    children: [
      {
        path: 'card-list',
        name: 'verifyCardList',
        component: () => import('@/views/verify/card-list/index'),
        meta: {title: '核销卡券列表', icon: 'sms-coupon', allowWithoutMenu: true}
      },
      {
        path: 'manage',
        name: 'verifyManage',
        component: () => import('@/views/verify/index'),
        meta: {title: '核销管理', icon: 'form', allowWithoutMenu: true}
      }
    ]
  },
  /** 供应商：一级模块，与会员/核销一致；不依赖「商品」菜单即可展示 */
  {
    path: '/supplier',
    component: Layout,
    redirect: '/supplier/product',
    name: 'supplier',
    meta: {title: '供应商', icon: 'product-brand', alwaysShow: true, allowWithoutMenu: true},
    children: [
      {
        path: 'manage',
        name: 'pmsSupplier',
        component: () => import('@/views/pms/supplier/index'),
        meta: {title: '供应商管理', icon: 'product-brand', allowWithoutMenu: true}
      },
      {
        path: 'goods',
        name: 'supplierProductList',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '供货商品', icon: 'product-list', allowWithoutMenu: true, supplierSupplyMode: true}
      },
      {
        path: 'goods/add',
        name: 'supplierProductAdd',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加供货商品', allowWithoutMenu: true, supplierSupplyMode: true},
        hidden: true
      },
      {
        path: 'goods/update',
        name: 'supplierProductUpdate',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '编辑供货商品', allowWithoutMenu: true, supplierSupplyMode: true},
        hidden: true
      },
      {
        path: 'goods/editMobileDetail',
        name: 'supplierProductEditMobile',
        component: () => import('@/views/pms/product/editMobileDetail'),
        meta: {title: '编辑移动端详情', allowWithoutMenu: true, supplierSupplyMode: true},
        hidden: true
      },
      {
        path: 'product',
        name: 'pmsRealProduct',
        component: () => import('@/views/pms/realProduct/index'),
        meta: {title: '供应商产品管理', icon: 'product-list', allowWithoutMenu: true}
      },
      {
        path: 'backfill',
        name: 'pmsRealProductBackfill',
        component: () => import('@/views/pms/realProduct/BackfillPage'),
        meta: {title: '数据回填', icon: 'document', allowWithoutMenu: true}
      },
      {
        path: 'product/sku/:skuId',
        name: 'pmsSkuRealProductRelate',
        component: () => import('@/views/pms/realProduct/SkuRelatePage'),
        meta: {title: '关联供应商产品', icon: 'product-list', allowWithoutMenu: true},
        hidden: true
      }
    ]
  },
  /** 旧路径：商品下供应商中心 → 一级供应商模块 */
  { path: '/pms/supplierCenter', redirect: '/supplier/product', hidden: true },
  { path: '/pms/supplierCenter/manage', redirect: '/supplier/manage', hidden: true },
  { path: '/pms/supplierCenter/product', redirect: '/supplier/product', hidden: true },
  { path: '/pms/supplierCenter/backfill', redirect: '/supplier/backfill', hidden: true },
  {
    path: '/pms/supplierCenter/product/sku/:skuId',
    redirect: (to) => `/supplier/product/sku/${to.params.skuId}`,
    hidden: true
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: {title: '商品列表', icon: 'product-list'}
      },
      {
        path: 'lowStockSku',
        name: 'lowStockSku',
        component: () => import('@/views/pms/product/lowStockSku'),
        meta: {title: '低库存SKU', icon: 'product-list', allowWithoutMenu: true}
      },
      {
        path: 'homeHotSearch',
        name: 'homeHotSearch',
        component: () => import('@/views/sms/hotSearch/index.vue'),
        meta: {
          title: '检索词',
          icon: 'document',
          allowWithoutMenu: true
        }
      },
      {
        path: 'serviceFlowGlobal',
        name: 'serviceFlowGlobal',
        component: () => import('@/views/pms/serviceFlow/global-template'),
        meta: {
          title: '到店服务模版',
          icon: 'product-attr',
          allowWithoutMenu: true
        }
      },
      {
        path: 'pickupFlowGlobal',
        name: 'pickupFlowGlobal',
        component: () => import('@/views/pms/pickupFlow/global-template'),
        meta: {
          title: '到店自提模版',
          icon: 'product-attr',
          allowWithoutMenu: true
        }
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        redirect: { name: 'innerRedeemProductAdd' },
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'innerRedeemProduct',
        name: 'innerRedeemProductList',
        component: () => import('@/views/pms/innerRedeemProduct/index'),
        /** 临时隐藏侧栏入口；路由保留。恢复：去掉 hidden 与 meta.forceHideInSidebar */
        hidden: false,
        /** 后端未配置菜单名时仍注册；forceHideInSidebar 见 permission.js，避免被后台菜单显示 */
        meta: {title: '兑换积分商品', icon: 'product-list', allowWithoutMenu: true, forceHideInSidebar: true}
      },
      {
        path: 'innerRedeemProduct/add',
        name: 'innerRedeemProductAdd',
        component: () => import('@/views/pms/innerRedeemProduct/add'),
        /** 与列表路由一致：UMS 未单独配置菜单名时仍注册，否则 permission 会过滤掉导致侧栏无入口 */
        meta: {title: '新建兑换积分商品', icon: 'product-add', allowWithoutMenu: true},
        hidden: true
      },
      {
        path: 'innerRedeemProduct/update',
        name: 'innerRedeemProductUpdate',
        component: () => import('@/views/pms/innerRedeemProduct/update'),
        meta: {title: '编辑兑换积分商品', icon: 'product-add', allowWithoutMenu: true},
        hidden: true
      },
      {
        path: 'innerRedeemProduct/preview',
        name: 'innerRedeemProductPreview',
        component: () => import('@/views/pms/innerRedeemProduct/productPreview'),
        meta: {title: '商品预览', icon: 'product-add', allowWithoutMenu: true},
        hidden: true
      },
      {
        path: 'editMobileDetail',
        name: 'editMobileDetail',
        component: () => import('@/views/pms/product/editMobileDetail'),
        meta: {title: '编辑移动端详情', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      /** 旧路径兼容：商品下供应商入口 → 一级供应商模块 */
      { path: 'supplierCenter', redirect: '/supplier/product', hidden: true },
      { path: 'supplierCenter/manage', redirect: '/supplier/manage', hidden: true },
      { path: 'supplierCenter/product', redirect: '/supplier/product', hidden: true },
      { path: 'supplierCenter/backfill', redirect: '/supplier/backfill', hidden: true },
      {
        path: 'supplierCenter/product/sku/:skuId',
        redirect: (to) => `/supplier/product/sku/${to.params.skuId}`,
        hidden: true
      },
      { path: 'supplier', redirect: '/supplier/manage', hidden: true },
      { path: 'realProduct', redirect: '/supplier/product', hidden: true },
      {
        path: 'realProduct/sku/:skuId',
        redirect: (to) => `/supplier/product/sku/${to.params.skuId}`,
        hidden: true
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      },
      {
        path: 'freightConfig',
        name: 'freightConfig',
        component: () => import('@/views/pms/freight/index'),
        meta: {title: '运费管理', icon: 'order-setting', allowWithoutMenu: true}
      },
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'shipmentRecord',
        name: 'shipmentRecord',
        component: () => import('@/views/oms/order/shipmentRecord'),
        meta: {title: '发货信息', icon: 'order', superAdminOnly: true}
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'expressCompany',
        name: 'omsExpressCompany',
        component: () => import('@/views/oms/expressCompany/index'),
        meta: {title: '快递公司名录', icon: 'order-setting', allowWithoutMenu: true}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    /** 临时隐藏侧栏「营销」模块（路由保留；去掉 hidden + meta.forceHideInSidebar 即可恢复） */
    hidden: true,
    meta: {title: '营销', icon: 'sms', forceHideInSidebar: true},
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: {title: '秒杀活动列表', icon: 'sms-flash'}
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: {title: '秒杀时间段列表'},
        hidden:true
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: {title: '秒杀时间段选择'},
        hidden:true
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: {title: '秒杀商品列表'},
        hidden:true
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: {title: '优惠券列表', icon: 'sms-coupon'}
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: {title: '添加优惠券'},
        hidden:true
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: {title: '修改优惠券'},
        hidden:true
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: {title: '优惠券领取详情'},
        hidden:true
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: {title: '品牌推荐', icon: 'product-brand'}
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: {title: '新品推荐', icon: 'sms-new'}
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: {title: '人气推荐', icon: 'sms-hot'}
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: {title: '专题推荐', icon: 'sms-subject'}
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'admin/allocRole',
        name: 'allocAdminRole',
        component: () => import('@/views/ums/admin/allocRole'),
        meta: {title: '分配角色与能力'},
        hidden: true
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      },
      {
        path: 'open-api-client',
        name: 'openApiClient',
        component: () => import('@/views/ums/open-api-client/index'),
        meta: {title: 'Open API 客户端', icon: 'ums-resource', superAdminOnly: true, allowWithoutMenu: true}
      },
      {
        path: 'open-api-user-grant',
        name: 'openApiUserGrant',
        component: () => import('@/views/ums/open-api-user-grant/index'),
        meta: {title: 'Open API 用户授权', icon: 'ums-resource', superAdminOnly: true, allowWithoutMenu: true}
      },
      {
        path: 'open-api-user-grant/allocScope',
        name: 'openApiUserGrantAllocScope',
        component: () => import('@/views/ums/open-api-user-grant/allocScope'),
        meta: {title: '配置第三方授权范围', superAdminOnly: true, forceHideInSidebar: true},
        hidden: true
      },
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

function silenceExpectedNavigationFailure(err) {
  if (
    isNavigationFailure(err, NavigationFailureType.redirected) ||
    isNavigationFailure(err, NavigationFailureType.duplicated)
  ) {
    return err
  }
  return Promise.reject(err)
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(silenceExpectedNavigationFailure)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject)
  }
  return originalReplace.call(this, location).catch(silenceExpectedNavigationFailure)
}

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js